import React from 'react'

import { ReactComponent as UserDoctor } from '../../../../../assets/icons/house-chimney-medical.svg'
import { ReactComponent as UserCircle } from '../../../../../assets/icons/user-circle.svg'
import * as S from './styles'

const ClinicInfo = ({ userData }) => {
  const partnerName = userData.partnerName
  const sameProfessionalStore = userData.professional.sameProfessionalStore

  const abbreviatesProfessionalName = (professionalName) => {
    const name = professionalName.split(' ')[0]
    return name.length >= 10 ? `${name.substring(0, 7)}...` : name
  }

  const nameOfProfessionalsMinimized = () => {
    return sameProfessionalStore.map((professional, index) => {
      if (index >= 4) {
        return <S.TooltipItem key={`${professional.name}-${index}`} >{abbreviatesProfessionalName(professional.name)}</S.TooltipItem>
      }
    })
  }

  return <>
    <S.Container>
      <S.WrapperClinic>
        <UserDoctor />
        <S.WrapperText>
          <S.ClinicName>{partnerName}</S.ClinicName>
          <S.Text>
            {sameProfessionalStore.length === 1
              ? '1 Médico veterinário'
              : `${sameProfessionalStore.length} Médicos veterinários`}
          </S.Text>
        </S.WrapperText>
      </S.WrapperClinic>
      <S.WrapperVets>
        {sameProfessionalStore.map((vet, index) => {
          return index <= 3 && (
            <S.Vet key={`${vet.name}-${index}`}>
              <UserCircle />
              <S.VetName>{abbreviatesProfessionalName(vet.name)}</S.VetName>
            </S.Vet>
          )
        }
        )}

        {sameProfessionalStore.length > 4 && (
          <S.Tooltip>
            <S.Vet>
              <UserCircle />
              <S.VetName>+{sameProfessionalStore.length - 4}</S.VetName>
              <S.TooltipText className='tooltiptext'>
                {nameOfProfessionalsMinimized()}
              </S.TooltipText>
            </S.Vet>
          </S.Tooltip>
        )}

      </S.WrapperVets>
    </S.Container>
  </>
}

export default ClinicInfo
